import React from 'react'

const CreateReminder = ({ setcreateEvent }) => {
    // Function to generate options for select
    const generateOptions = () => {
        const options = [];
        for (let hour = 0; hour < 12; hour++) {
            options.push(
                <option key={hour} value={hour === 0 ? 12 : hour}>
                    {hour === 0 ? 12 : hour} AM
                </option>
            );
        }
        for (let hour = 12; hour < 24; hour++) {
            options.push(
                <option key={hour} value={hour === 12 ? 12 : hour - 12}>
                    {hour === 12 ? 12 : hour - 12} PM
                </option>
            );
        }
        return options;
    };

    return (
        <div style={{ marginTop: "35px" }}>
            <div >
                <input className='input-eventt' placeholder={"Reminder Name"} />
                <input type='date' className='input-eventt' />
            </div>
            <div className='two-select'>
                <select className='one-select-event' >
                    {generateOptions()}
                </select>
                <select className='one-select-event'>
                    {generateOptions()}
                </select>
            </div>
            <div className='two-select-bottom' style={{marginTop: "50px"}} >
                <select>
                    <option selected >Repeat </option>
                    <option>None</option>
                    <option>Every Day</option>
                    <option>Every Week</option>
                    <option>Every Month</option>
                    <option>Every Year</option>
                </select>
                <select>
                    <option selected >Alert </option>
                    <option>None</option>
                    <option>At time of event</option>
                    <option>5 minutes before</option>
                    <option>10 minutes before</option>
                    <option>15 minutes before</option>
                </select>
            </div>
            <div className='btn-event' style={{marginTop: "40px"}} >
                <button className="cancel" style={{ marginRight: "20px" }} onClick={() => setcreateEvent(false)} >
                    Cancel
                </button>
                <button className="create"
                >Create Reminder</button>

            </div>
        </div>
    )
}

export default CreateReminder